var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg53(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M46.32,19.94l-0.7-0.76c-0.14-0.16-0.32-0.27-0.56-0.35c-0.05-0.02-0.12-0.03-0.22-0.04l-0.14-0.01 c-0.29,0-0.57,0.1-0.79,0.28l-10.6,7.35c-0.09,0.06-0.19,0.09-0.3,0.09c-0.17,0-0.4-0.09-0.5-0.34l-1.58-3.97 c-0.5-1.26-1.69-2.07-3.04-2.07h-6.49v-1.5h3.59c0.43,0,0.79-0.39,0.79-0.87v-0.02c0-0.48-0.35-0.87-0.79-0.87h-9.11 c-0.43,0-0.79,0.39-0.79,0.87v0.02c0,0.48,0.35,0.87,0.79,0.87h3.59v1.5h-6.98c0.04-0.17,0.06-0.35,0.07-0.54l0.02-0.68 c0.04-1.36-0.9-2.53-2.23-2.8l-6.4-1.29c-0.99-0.2-1.94,0.34-2.31,1.24l-0.61,1.49c-0.2,0.49-0.19,1.05,0.04,1.53 c0.23,0.48,0.65,0.84,1.16,0.99l6.83,2.04c0.26,0.08,0.52,0.12,0.78,0.12c0.05,0,0.1-0.01,0.15-0.01v10.52 c0,1.81,1.47,3.27,3.27,3.27h17.99c2.68,0,5.19-1.33,6.69-3.55l6.86-10.13c0.07-0.11,0.19-0.17,0.32-0.17 c0.3-0.01,0.65-0.05,0.93-0.31l0.16-0.14c0.24-0.22,0.39-0.52,0.41-0.85C46.66,20.52,46.55,20.18,46.32,19.94z M10.71,19.54 c-0.02,0.54-0.56,0.96-1.11,0.8l-6.85-2.08l0.61-1.49c0.03-0.07,0.1-0.12,0.22-0.12c0,0,0.01,0,0.01,0l6.4,1.29 c0.44,0.09,0.75,0.48,0.74,0.93L10.71,19.54z M36.42,31.42c-1.16,1.71-3.09,2.73-5.15,2.73H13.27c-0.78,0-1.42-0.64-1.42-1.42 V22.09c0-0.06,0.05-0.1,0.1-0.1H27.9c0.58,0,1.1,0.35,1.32,0.89l1.58,3.97c0.36,0.92,1.24,1.51,2.22,1.51 c0.48,0,0.95-0.15,1.35-0.42l8.32-5.76L36.42,31.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M45.87,22.66l0.21,0.39c0.57,1.07,0.94,2.24,1.08,3.45l0.06,0.47c0.06,0.52-0.35,0.98-0.87,0.98h-0.02 c-0.59,0-1.01-0.57-0.84-1.13l0.03-0.09c0.35-1.15,0.48-2.36,0.39-3.56L45.87,22.66z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg53);
export default __webpack_public_path__ + "static/media/53.85243b1cb49615abebec7f1c010e97e6.svg";
export { ForwardRef as ReactComponent };